import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router";
import { Breadcrumbs } from "src/components/Breadcrumb/Breadcrumbs";

type SettingsBreadcrumb = {
    label: string;
    to?: string;
};

type SettingsPageHeaderProps = {
    title: string;
    subtitle?: string;
    breadcrumbs?: SettingsBreadcrumb[];
    children?: ReactNode;
};

export const SettingsPageHeader = ({ title, subtitle, breadcrumbs = [], children }: SettingsPageHeaderProps) => {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Box sx={{ marginBottom: theme.spacing(4), minWidth: 0, flex: 1 }}>
            <Box sx={{ minWidth: 0, flex: 1 }}>
                {breadcrumbs.length > 0 ?
                    <Box sx={{ mb: theme.spacing(2) }}>
                        <Breadcrumbs
                            items={breadcrumbs.map((item) => ({
                                label: item.label,
                                action: item.to ? () => navigate(item.to as string) : undefined,
                            }))}
                        />
                    </Box>
                :   null}

                {breadcrumbs.length === 0 ?
                    <Typography variant="h3" sx={{ color: theme.custom.grey[2800] }}>
                        {title}
                    </Typography>
                :   null}
                {subtitle ?
                    <Typography variant="body" sx={{ color: theme.custom.grey[2100], display: "block" }}>
                        {subtitle}
                    </Typography>
                :   null}
            </Box>

            {children}
        </Box>
    );
};
